import React, { FC, ReactElement, useState } from 'react';
import {
  Typography, TextField, Button, Grid, InputAdornment,
} from '@material-ui/core';
import { ListRowProps } from 'react-virtualized';
import accounting from 'accounting';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

interface ProductListItemProps {
  mode: 'add' | 'remove',
  product: {
    brand: string, inRutaShortDescriptionSpanish: string,
    vendorPrice: number, id: string, inRutaCode: number
  },
  price?: number,
  baseMarkup: number,
  listProps: ListRowProps,
  onClick: (productId: string, price?: number) => void,
}

const ProductListItem: FC<ProductListItemProps> = (props): ReactElement => {
  const {
    mode, product, baseMarkup, listProps, price,
  } = props;
  const [productPrice, setProductPrice] = useState(price ? `${price}` : '');
  const {
    brand, inRutaShortDescriptionSpanish, vendorPrice, inRutaCode,
  } = product;
  const baseSalesPrice = vendorPrice * (1 + baseMarkup / 100);
  const formattedVendorPrice = accounting.formatMoney(vendorPrice / 100);
  const formattedBaseSalesPrice = accounting.formatMoney(baseSalesPrice / 100);
  const rowHeight = 100;
  const rowPadding = 5;
  const rowContentHeight = rowHeight - 2 * rowPadding;
  const tableWidth = 600;
  return (
    <Grid
      container
      key={listProps.index}
      style={{ ...listProps.style, width: `${tableWidth}px`, height: `${rowHeight}px` }}
    >
      <Grid
        item
        xs={10}
        style={{
          paddingTop: `${rowPadding}px`, paddingBottom: `${rowPadding}px`, height: rowContentHeight,
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography
              variant="body1"
              style={{
                width: '70%',
                display: 'inline-block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {`${brand}, ${inRutaShortDescriptionSpanish}, IR#${inRutaCode}`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1" style={{ display: 'inline', paddingRight: '1rem' }}>{`Distro Price: ${formattedVendorPrice}`}</Typography>
            <Typography variant="body1" style={{ display: 'inline', paddingLeft: '1rem', paddingRight: '1rem' }}>{`Our Price: ${formattedBaseSalesPrice}`}</Typography>
            <Typography variant="body1" style={{ display: 'inline', paddingLeft: '1rem', paddingRight: '1rem' }}>{`Base Markup: ${baseMarkup}%`}</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              id="input-with-icon-textfield"
              placeholder="New Price"
              defaultValue={productPrice?.length > 0 ? `${Number.parseInt(productPrice, 10) / 100}` : productPrice}
              onChange={(event) => setProductPrice(event.target.value)}
              contentEditable={mode === 'add'}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    $
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={2} style={{ paddingTop: `${rowPadding}px`, paddingBottom: `${rowPadding}px`, height: `${rowContentHeight}px` }}>
        { mode === 'add' ? (
          <Button
            style={{ width: '4rem', display: 'inline', height: `${rowContentHeight}px` }}
            onClick={() => {
              const aPrice = Number.parseInt(productPrice.replace('.', ''), 10);
              props.onClick(product.id, aPrice);
            }}
          >
            <FontAwesomeIcon icon={faPlus} size="2x" />
          </Button>
        ) : (
          <Button
            style={{ width: '4rem', display: 'inline', height: `${rowContentHeight}px` }}
            onClick={() => {
              props.onClick(product.id);
            }}
          >
            <FontAwesomeIcon icon={faTimesCircle} size="2x" />
          </Button>
        )}
      </Grid>
    </Grid>
  );
};

export default ProductListItem;
